import axiosInstance from "auth/FetchInterceptor";
import {
  CONFIRM_TRANSFER,
  CREATE_TRANSFER,
  CREATE_RECEIPT,
  DELETE_TRANSFER,
  DELETE_TRANSFER_MATERIAL,
  DELETE_RECEIPT,
  DETAIL_TRANSFER,
  GENERATE_TRANSFER,
  GENERATE_RECEIPT,
  TRANSFER_SEARCH_GRID,
  UPDATE_TRANSFER,
  UPDATE_TRANSFER_RECEIVED_QUANTITY,
  UPDATE_RECEIPT,
  UPDATE_RECEIPT_PARTIAL,
  RECEIPT_SEARCH_GRID,
  UPDATE_RECEIPT_MATERIAL,
  DELETE_RECEIPT_MATERIAL,
  DETAIL_RECEIPT,
  CHECK_SEARCH_GRID,
  GENERATE_CHECK,
  CREATE_CHECK,
  UPDATE_CHECK,
  CANCEL_CHECK,
  DETAIL_CHECK,
  WAREHOUSE_UNIT,
  UPDATE_RECEIPT_V2,
  CONFIRM_TRANSFER_V2,
  UPDATE_CHECK_V2,
  GENERATE_RECEIPT_V2,
  GENERATE_TRANSFER_V2,
  GENERATE_CHECK_V2,
} from "constants/ApiConstant";

const WarehouseReceiptService = {};

//NHẬP KHO
WarehouseReceiptService.getAllWarehouseReceipt = function (data) {
  return axiosInstance.post(RECEIPT_SEARCH_GRID, data);
};
WarehouseReceiptService.generateWarehouseReceipt = function (data) {
  return axiosInstance.post(GENERATE_RECEIPT, data);
};
WarehouseReceiptService.createWarehouseReceipt = function (data) {
  return axiosInstance.post(CREATE_RECEIPT, data);
};
WarehouseReceiptService.updateWarehouseReceipt = function (data) {
  return axiosInstance.put(UPDATE_RECEIPT, data);
};
WarehouseReceiptService.updateWarehouseReceiptPartial = function (data) {
  return axiosInstance.put(UPDATE_RECEIPT_PARTIAL, data);
};
WarehouseReceiptService.updateWarehouseReceiptMaterial = function (data) {
  return axiosInstance.put(UPDATE_RECEIPT_MATERIAL, data);
};
WarehouseReceiptService.deleteWarehouseReceipt = function (id) {
  return axiosInstance.delete(`${DELETE_RECEIPT}/${id}`, null);
};
WarehouseReceiptService.deleteWarehouseReceiptMaterial = function (id) {
  return axiosInstance.delete(`${DELETE_RECEIPT_MATERIAL}/${id}`, null);
};
WarehouseReceiptService.getDetailWarehouseReceipt = function (id) {
  return axiosInstance.get(`${DETAIL_RECEIPT}/${id}`, null);
};
//V2
WarehouseReceiptService.updateWarehouseReceiptV2 = function (data) {
  return axiosInstance.put(UPDATE_RECEIPT_V2, data);
};
WarehouseReceiptService.generateWarehouseReceiptV2 = function (data) {
  return axiosInstance.post(GENERATE_RECEIPT_V2, data);
};

//TRANSFER (XUẤT CHUYỂN KHO?)
WarehouseReceiptService.getAllTransfer = function (data) {
  return axiosInstance.post(TRANSFER_SEARCH_GRID, data);
};
WarehouseReceiptService.generateTransfer = function (data) {
  return axiosInstance.post(GENERATE_TRANSFER, data);
};
WarehouseReceiptService.createTransfer = function (data) {
  return axiosInstance.post(CREATE_TRANSFER, data);
};
WarehouseReceiptService.updateTransfer = function (data) {
  return axiosInstance.put(UPDATE_TRANSFER, data);
};
WarehouseReceiptService.updateTransferReceivedQuantity = function (data) {
  return axiosInstance.put(UPDATE_TRANSFER_RECEIVED_QUANTITY, data);
};
WarehouseReceiptService.deleteTransfer = function (id) {
  return axiosInstance.delete(`${DELETE_TRANSFER}/${id}`, null);
};
WarehouseReceiptService.deleteTransferMaterial = function (id) {
  return axiosInstance.delete(`${DELETE_TRANSFER_MATERIAL}/${id}`, null);
};
WarehouseReceiptService.confirmTransfer = function (data) {
  return axiosInstance.post(CONFIRM_TRANSFER, data);
};
WarehouseReceiptService.getDetailTransfer = function (data) {
  return axiosInstance.get(
    `${DETAIL_TRANSFER}/${data.id}/${data.storeId}`,
    null,
  );
};
//V2
WarehouseReceiptService.confirmTransferV2 = function (data) {
  return axiosInstance.post(CONFIRM_TRANSFER_V2, data);
};
WarehouseReceiptService.generateTransferV2 = function (data) {
  return axiosInstance.post(GENERATE_TRANSFER_V2, data);
};

//WAREHOUSE CHECK (KIỂM KHO)
WarehouseReceiptService.getAllCheck = function (data) {
  return axiosInstance.post(CHECK_SEARCH_GRID, data);
};
WarehouseReceiptService.generateCheck = function (data) {
  return axiosInstance.post(GENERATE_CHECK, data);
};
WarehouseReceiptService.createCheck = function (data) {
  return axiosInstance.post(CREATE_CHECK, data);
};
WarehouseReceiptService.updateCheck = function (data) {
  return axiosInstance.put(UPDATE_CHECK, data);
};
WarehouseReceiptService.cancelCheck = function (payload) {
  return axiosInstance.put(`${CANCEL_CHECK}/${payload.id}`, null);
};
WarehouseReceiptService.detailCheck = function (id) {
  return axiosInstance.get(`${DETAIL_CHECK}/${id}`, null);
};
//V2
WarehouseReceiptService.updateCheckV2 = function (data) {
  return axiosInstance.put(UPDATE_CHECK_V2, data);
};
WarehouseReceiptService.generateCheckV2 = function (data) {
  return axiosInstance.post(GENERATE_CHECK_V2, data);
};

WarehouseReceiptService.getWarehouseUnit = function (data) {
  return axiosInstance.post(WAREHOUSE_UNIT, data);
};

export default WarehouseReceiptService;
